module.exports = __webpack_public_path__ + "img/LR.39043415.png";